import * as React from 'react';

export function useIsMobile() {
  const [isMobile, setIsMobile] = React.useState<boolean | undefined>(undefined);

  React.useEffect(() => {
    const breakpoint = getComputedStyle(document.documentElement).getPropertyValue('--breakpoint-md').trim();
    if (!breakpoint) return;

    const mql = window.matchMedia(`(width < ${breakpoint})`);
    const onChange = () => {
      setIsMobile(mql.matches);
    };
    mql.addEventListener('change', onChange);
    onChange();
    return () => mql.removeEventListener('change', onChange);
  }, []);

  return !!isMobile;
}
